// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
.tim-row {
  margin-bottom: 20px;
}

.tim-white-buttons {
  background-color: #777777;
}

.typography-line {
  padding-left: 25%;
  margin-bottom: 35px;
  position: relative;
  display: block;
  width: 100%;
}

.typography-line span {
  bottom: 10px;
  color: #c0c1c2;
  display: block;
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  left: 0;
  position: absolute;
  width: 260px;
  text-transform: none;
}

.tim-row {
  padding-top: 60px;
}

.tim-row h3 {
  margin-top: 0;
}

.offline-doc .page-header {
  display: flex;
  align-items: center;
}

.offline-doc .footer {
  position: absolute;
  width: 100%;
  background: transparent;
  bottom: 0;
  color: var(--white);
  z-index: 1;
  padding-left: 0;
}

@media all and (min-width: 992px) {
  .sidebar .nav > li.active-pro {
    position: absolute;
    width: 100%;
    bottom: 10px;
  }
}

.card.card-upgrade .card-category {
  max-width: 530px;
  margin: 0 auto;
}

.offline-doc .page-header {
  min-height: 100vh;
  max-height: 999px;
  padding: 0;
  color: var(--white);
  position: relative;
}
.offline-doc .page-header .page-header-image {
  position: absolute;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.offline-doc .page-header .content-center {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);
  text-align: center;
  color: var(--white);
  padding: 0 15px;
  width: 100%;
  max-width: 880px;
}
.offline-doc .page-header footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.offline-doc .page-header .container {
  height: 100%;
  z-index: 1;
}
.offline-doc .page-header .category,
.offline-doc .page-header .description {
  color: rgba(255, 255, 255, 0.8);
}
.offline-doc .page-header.page-header-small {
  min-height: 60vh;
  max-height: 440px;
}
.offline-doc .page-header.page-header-mini {
  min-height: 40vh;
  max-height: 340px;
}
.offline-doc .page-header .title {
  margin-bottom: 15px;
}
.offline-doc .page-header .title + h4 {
  margin-top: 10px;
}
.offline-doc .page-header:after,
.offline-doc .page-header:before {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
}
.offline-doc .page-header:before {
  background-color: rgba(0, 0, 0, 0.8);
}
`, "",{"version":3,"sources":["webpack://./src/assets/demo/demo.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;CAgBC;AACD;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EAGV,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,OAAO;EACP,MAAM;EACN,WAAW;AACb;AACA;EACE,oCAAoC;AACtC","sourcesContent":["/*!\n\n=========================================================\n* Black Dashboard React v1.2.2\n=========================================================\n\n* Product Page: https://www.creative-tim.com/product/black-dashboard-react\n* Copyright 2023 Creative Tim (https://www.creative-tim.com)\n* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)\n\n* Coded by Creative Tim\n\n=========================================================\n\n* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\n*/\n.tim-row {\n  margin-bottom: 20px;\n}\n\n.tim-white-buttons {\n  background-color: #777777;\n}\n\n.typography-line {\n  padding-left: 25%;\n  margin-bottom: 35px;\n  position: relative;\n  display: block;\n  width: 100%;\n}\n\n.typography-line span {\n  bottom: 10px;\n  color: #c0c1c2;\n  display: block;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 13px;\n  left: 0;\n  position: absolute;\n  width: 260px;\n  text-transform: none;\n}\n\n.tim-row {\n  padding-top: 60px;\n}\n\n.tim-row h3 {\n  margin-top: 0;\n}\n\n.offline-doc .page-header {\n  display: flex;\n  align-items: center;\n}\n\n.offline-doc .footer {\n  position: absolute;\n  width: 100%;\n  background: transparent;\n  bottom: 0;\n  color: var(--white);\n  z-index: 1;\n  padding-left: 0;\n}\n\n@media all and (min-width: 992px) {\n  .sidebar .nav > li.active-pro {\n    position: absolute;\n    width: 100%;\n    bottom: 10px;\n  }\n}\n\n.card.card-upgrade .card-category {\n  max-width: 530px;\n  margin: 0 auto;\n}\n\n.offline-doc .page-header {\n  min-height: 100vh;\n  max-height: 999px;\n  padding: 0;\n  color: var(--white);\n  position: relative;\n}\n.offline-doc .page-header .page-header-image {\n  position: absolute;\n  background-size: cover;\n  background-position: center center;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n.offline-doc .page-header .content-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 2;\n  -ms-transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  text-align: center;\n  color: var(--white);\n  padding: 0 15px;\n  width: 100%;\n  max-width: 880px;\n}\n.offline-doc .page-header footer {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n}\n.offline-doc .page-header .container {\n  height: 100%;\n  z-index: 1;\n}\n.offline-doc .page-header .category,\n.offline-doc .page-header .description {\n  color: rgba(255, 255, 255, 0.8);\n}\n.offline-doc .page-header.page-header-small {\n  min-height: 60vh;\n  max-height: 440px;\n}\n.offline-doc .page-header.page-header-mini {\n  min-height: 40vh;\n  max-height: 340px;\n}\n.offline-doc .page-header .title {\n  margin-bottom: 15px;\n}\n.offline-doc .page-header .title + h4 {\n  margin-top: 10px;\n}\n.offline-doc .page-header:after,\n.offline-doc .page-header:before {\n  position: absolute;\n  z-index: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  left: 0;\n  top: 0;\n  content: \"\";\n}\n.offline-doc .page-header:before {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
